import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  Page,
  Msg,
  LoadMore,
  Toast,
  Panel,
  PanelBody,
  MediaBox,
} from 'react-weui';
import PropTypes from 'prop-types';
import { formatDate, formatNumber } from 'lib/formatter.ts';
import Http from 'services/http2';
import * as MobileActions from '../../actions';

/* 供应商管理报表 */

class CustomerAdminReport extends Component {
  constructor(props) {
    super(props);
    this.reset = false;
    this.pageNum = 1;
    this.searchKey = '';
    this.total = 0;
    this.resolveLoading = () => { }; //引用InfiniteLoader中resolveLoading方法，用于重置列表加载状态
    this.count = [];
    this.state = {
      inited: false,
      error: null,
      dataError: null,
      detail: {},
      list: [],
      showLoading: true,
      isShowSearch: false,
    };
    const { match } = props;
    this.id = match.params.id;
  }

  init() {
    this.setState({
      inited: true,
    });
    this.getList();
  }

  componentDidMount() {
    this.init();
  }

  componentWillUnmount() { }

  getList(cb = () => { }) {
    let postbody = {
      apiPath: '/archives/customerAdminReport/public/preview',
      ssoToken: decodeURIComponent(this.id), //ssoToken中可能会有/
    };
    let arrPromise = [Http.post('/api/cloudCenter', postbody)];
    this.setState({
      dataError: null,
    });
    Promise.all(arrPromise).then(arrResponse => {
      let response = arrResponse[0];
      this.reset = false;
      this.setState({
        showLoading: false,
      });
      if (response.success) {
        if (response.data) {
          let data = response.data;
          this.setState({
            detail: data,
          });
          if (Array.isArray(data.list)) {
            this.setState(
              {
                list: this.state.list.concat(data.list),
              },
              () => cb()
            );
            this.pageNum += 1;
            this.total = data.list.length;
          }
        }
      } else {
        this.setState({
          dataError: {
            type: 'warn',
            title: response.errorMsg,
          },
        });
      }
    });
  }

  render() {
    if (this.state.error !== null) {
      return <Msg {...this.state.error} />;
    }
    return (
      <Page
        transition={false}
        ptr={false}
        onLoadMore={(resolveLoading, finish) => {
          this.resolveLoading = resolveLoading;
          if (this.state.list.length >= this.total) {
            finish();
          } else {
            this.getList(resolveLoading);
          }
        }}
      >
        <Panel>
          {this.state.dataError !== null ? (
            <Msg {...this.state.dataError} />
          ) : (
            <div className="m-report-container">
              {/* header */}
              <div className='header'>{this.state.detail.companyName}</div>
              {/* banner */}
              {/* <div className="m-card-wrap">
                <div className="wrap-body">
                  <div className="banner" style={{ backgroundImage: 'url(https://xieke-mail.oss-cn-shenzhen.aliyuncs.com/iaa/banner.jpg)' }}></div>
                </div>
              </div> */}
              <div className="list-total">{this.total}</div>
              <PanelBody>
                {/* 销售数据 */}
                <div className="m-details-item">
                  <div className="details-item-content">
                    <div className="content-line line-list-item">
                      <div className="line-list-item-title">
                        <span><b>销售数据</b></span>
                      </div>
                      <table className="m-table">
                        <thead>
                          <tr>
                            <th className="w55">客户名称</th>
                            <th>订单数</th>
                            <th>订单金额</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.list?.map((item, index) => (
                            <tr key={index}>
                              <td><p>{item.innerCustomerName}</p></td>
                              <td><p>{formatNumber(item.orderQty, '2')}</p></td>
                              <td><p>{formatNumber(item.orderTotalAmount, '2')}</p></td>
                              <td>
                                {
                                  item.fluctuationOfPricesFlag === 1 && <i className="icon-arrow-up green"></i>
                                }
                                {
                                  item.fluctuationOfPricesFlag === -1 && <i className="icon-arrow-down red"></i>
                                }
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                {/* 出货数据 */}
                <div className="m-details-item">
                  <div className="details-item-content">
                    <div className="content-line line-list-item">
                      <div className="line-list-item-title">
                        <span><b>出货数据</b></span>
                      </div>
                      <table className="m-table">
                        <thead>
                          <tr>
                            <th className="w55">客户名称</th>
                            <th>出货金额</th>
                            <th>出货异常</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.list?.map((item, index) => (
                            <tr key={index}>
                              <td><p>{item.innerCustomerName}</p></td>
                              <td><p>{formatNumber(item.deliveryTotalAmount, '2')}</p></td>
                              <td><p className='red'>{item.deliveryAbnormalQty}</p></td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                {/* 询价招标数据 */}
                <div className="m-details-item">
                  <div className="details-item-content">
                    <div className="content-line line-list-item">
                      <div className="line-list-item-title">
                        <span><b>询价招标数据</b></span>
                      </div>
                      <table className="m-table">
                        <thead>
                          <tr>
                            <th className="w55">客户名称</th>
                            <th>询价招标</th>
                            <th>报价</th>
                            <th>入选</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.list?.map((item, index) => (
                            <tr key={index}>
                              <td><p>{item.innerCustomerName}</p></td>
                              <td><p>{item.inquiryQty}</p></td>
                              <td><p>{item.quoteQty}</p></td>
                              <td><p>{item.beSelectedQty}</p></td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                {/* 客户绩效 */}
                <div className="m-details-item">
                  <div className="details-item-content">
                    <div className="content-line line-list-item">
                      <div className="line-list-item-title">
                        <span><b>客户绩效</b></span>
                      </div>
                      <table className="m-table">
                        <thead>
                          <tr>
                            <th className="w55">客户名称</th>
                            <th>绩效得分</th>
                            <th>绩效评级</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.list?.map((item, index) => (
                            <tr key={index}>
                              <td><p>{item.innerCustomerName}</p></td>
                              <td><p>{item.performanceScore}</p></td>
                              <td><p className={['C', 'D'].includes(item.gradeInfo) ? 'red' : ''}>{item.gradeInfo}</p></td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                {!this.state.showLoading && this.state.list.length === 0 && (
                  <LoadMore showLine> 暂无数据</LoadMore>
                )}
              </PanelBody>
            </div>
          )}
        </Panel>
        <Toast icon="loading" show={this.state.showLoading}>
          数据加载中...
        </Toast>
      </Page>
    );
  }
}

CustomerAdminReport.propTypes = {
  data: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
};

const mapStateToProps = state => {
  return {
    data: state.login,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomerAdminReport);
